import { Metadata } from '@/service/interface';
import { StylefilterDetailDto } from '@/service/type';

export const StyleFilter = ({
  styleFilterObj,
  metadata,
}: {
  styleFilterObj: StylefilterDetailDto | null | undefined;
  metadata: Metadata | null | undefined;
}) => {
  let styleFilterCode = styleFilterObj?.code;
  if (styleFilterCode && styleFilterCode.endsWith('-HIGH')) {
    styleFilterCode = styleFilterCode.substring(0, styleFilterCode.lastIndexOf('-'));
  }

  const sfStrengthWord = metadata?.filterStrengthSetting === 0 ? 'Low Strength' : 'High Strength';
  return (
    <div className="px-[8px]  mt-[16px] w-fit max-w-[340px] ml-[8px]">
      {styleFilterObj && (
        <>
          <div className=" text-jen-size-heading-07 text-jen-content-tertiary">
            STYLEFILTER<sup className=" scale-75">TM</sup>
          </div>
          <div
            className="flex gap-[10px] mt-[8px] p-[3px] rounded-[6px]  w-fit max-w-full h-[44px] bg-[#191a1b]"
            style={{
              boxShadow:
                '20px 19px 8px 0px rgba(0, 0, 0, 0.00), 13px 12px 7px 0px rgba(0, 0, 0, 0.02), 7px 7px 6px 0px rgba(0, 0, 0, 0.06), 3px 3px 4px 0px rgba(0, 0, 0, 0.10), 1px 1px 2px 0px rgba(0, 0, 0, 0.12)',
              backdropFilter: 'blur(2px)',
            }}
          >
            {styleFilterObj?.thumb_album_cover ? (
              <img src={`${styleFilterObj?.thumb_album_cover}`} className="w-[24px] h-[38px] rounded-sm" />
            ) : (
              <div className="w-[24px] h-[38px] rounded-sm bg-jen-orange" />
            )}

            <div className="flex flex-col gap-1 justify-center min-w-0">
              <div className=" text-[8px] text-[#efeff0] font-pressura-mono leading-none">
                STYLEFILTER<sup className=" scale-75">TM</sup>
              </div>
              <div className="capitalize w-full  leading-[14px]  tracking-[-0.48px] text-[12px] text-[#efeff0] flex gap-1">
                <span className="shrink-0 ">{styleFilterObj?.name}</span>
                <span className="shrink-0">|</span>
                <span className="text-[#ffffff] opacity-70 truncate">
                  {sfStrengthWord}|{styleFilterObj?.artist_name}
                </span>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
